import queryString from 'query-string';
import { FC, useState } from 'react';
import { useMutation } from 'react-query';
import { useHistory, useLocation } from 'react-router';

import { AuthApi } from '../../api/client';
import { ROUTES } from '../../constants';
import { RegisterClinicAdminData } from '../../models';
import View from './View';

const Container: FC = () => {
  const { search } = useLocation();
  const { inviteId } = queryString.parse(search);
  const history = useHistory();
  const [errorMsg, setErrorMsg] = useState<string | null>(null);

  // navigate to admin dashboard
  const handleRedirect = () => {
    history.push(ROUTES.ADMIN_PANEL);
  };
  const registerClinicAdmin = useMutation(
    (data: RegisterClinicAdminData) => AuthApi.registerNewClinicAdmin(data),
    {
      onSuccess: () => {
        handleRedirect();
      },
      // If the mutation fails
      onError: (err: string) => {
        setErrorMsg(err);
        console.log(err);
      },
    }
  );

  const createAccount = (name: string, password: string) => {
    const data = { inviteId, name, password };
    registerClinicAdmin.mutate(data);
  };

  return (
    <View
      isLoading={registerClinicAdmin.isLoading}
      createAccount={createAccount}
      errorMsg={errorMsg}
    />
  );
};

export default Container;
